import { Box, Button, Container, Typography } from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import { useLogin, useNotify } from "react-admin";

const Login = () => {
  const login = useLogin();
  const notify = useNotify();

  const handleOidcLogin = () => {
    login({ username: "oidc", password: "oidc" }).catch((e) => {
      notify(e?.message || e || "Sign-in failed", { type: "warning" });
    });
  };

  const authority = process.env.REACT_APP_OIDC_AUTHORITY;
  const clientId = process.env.REACT_APP_OIDC_CLIENT_ID;

  return (
    <Box
      display="flex"
      flexGrow={1}
      justifyContent="center"
      alignItems="center"
      mt={10}
    >
      <Container maxWidth="xs">
        <Typography variant="h6" gutterBottom>
          Login
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Sign in with your organization&apos;s OpenID Connect provider.
        </Typography>
        {!authority || !clientId ? (
          <Typography color="error" variant="body2">
            OIDC is not configured. Set REACT_APP_OIDC_AUTHORITY and
            REACT_APP_OIDC_CLIENT_ID (and matching redirect URI in your IdP).
          </Typography>
        ) : (
          <Button
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            startIcon={<LoginIcon />}
            onClick={handleOidcLogin}
          >
            Sign in with SSO
          </Button>
        )}
      </Container>
    </Box>
  );
};

export default Login;
